export default __webpack_public_path__ + "static/media/commingSoon.deda70aa.svg";